var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "db relative overflow-hidden home-handle-overflow" },
          [
            _c(
              "div",
              { staticClass: "luxury-experiences--template page-template" },
              [
                _c("div", { staticClass: "relative container-fluid" }, [
                  _c(
                    "div",
                    {
                      staticClass: "db relative w-100 mw9 center pv4 z-content",
                    },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "f-page-title mv0 ttu is-blenny is-navy",
                        },
                        [_vm._v(_vm._s(_vm.page.title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mt0 mt0-ns" },
                        [
                          _vm._l(_vm.page.experiences, function (exp, index) {
                            return index < 2
                              ? _c(
                                  "div",
                                  {
                                    key: "luxury-experience-" + index,
                                    staticClass: "col-xs-12 col-sm-6 ph0 mt4",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "relative",
                                        class: {
                                          "bg-yellow": index == 0,
                                          "bg-navy": index == 1,
                                        },
                                      },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "db mt2 pt4 ph4 tl ttu f-page-h3 is-blenny",
                                            class: {
                                              "is-navy": index == 0,
                                              "is-yellow f-ggc-title":
                                                index == 1,
                                            },
                                          },
                                          [_vm._v(_vm._s(exp.title))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "f5 db mt2 pb4 ph4 tl ttu is-lorano-bold is-yellow f-ggc-sub-title",
                                          },
                                          [_vm._v(_vm._s(exp.sub_title))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "db absolute w-100 horiz-line-beige",
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass:
                                            "relative center img-responsive pa4",
                                          attrs: { src: exp.image },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "db absolute w-100 horiz-line-beige",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "relative pa4" },
                                          [
                                            _c("div", {
                                              staticClass: "mt3 f4 cms-content",
                                              class: {
                                                "is-navy": index == 0,
                                                "is-yellow": index == 1,
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.marked(exp.text)
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            exp.button_cta.is_disabled
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg btn-disabled o-60",
                                                    attrs: {
                                                      title:
                                                        exp.button_cta.copy,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : exp.button_cta.is_sold_out
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      title:
                                                        exp.button_cta.copy,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg link pointer",
                                                    attrs: {
                                                      href: exp.button_cta.link,
                                                      title: "Buy" + exp.title,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "dn db-ns absolute left-0 right-0 center vert-line-beige",
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "db relative mt4" }, [
                        _vm.page.vip_vs_ggp.is_published
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "db relative mt3" },
                                    [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value:
                                              _vm.page.vip_vs_ggp.mobile_image,
                                            expression:
                                              "page.vip_vs_ggp.mobile_image",
                                          },
                                        ],
                                        staticClass: "db dn-ns relative w-100",
                                        attrs: {
                                          alt: _vm.page.vip_vs_ggp.title,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value:
                                              _vm.page.vip_vs_ggp.desktop_image,
                                            expression:
                                              "page.vip_vs_ggp.desktop_image",
                                          },
                                        ],
                                        staticClass: "dn db-ns relative w-100",
                                        attrs: {
                                          alt: _vm.page.vip_vs_ggp.title,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mt0 mt3-ns" },
                        [
                          _vm._l(_vm.page.experiences, function (exp, index) {
                            return index > 1
                              ? _c(
                                  "div",
                                  {
                                    key: "luxury-experience-" + index,
                                    staticClass: "col-xs-12 col-sm-6 ph0 mt4",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "relative",
                                        class: {
                                          "bg-yellow": index == 2,
                                          "bg-navy": index == 3,
                                        },
                                      },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "db f1 mt2 pa4 tl ttu f-page-h3 is-blenny",
                                            class: {
                                              "is-navy": index == 2,
                                              "is-yellow": index == 3,
                                            },
                                          },
                                          [_vm._v(_vm._s(exp.title))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "db absolute w-100 horiz-line-beige",
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass:
                                            "relative center img-responsive pa4",
                                          attrs: { src: exp.image },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "db absolute w-100 horiz-line-beige",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "relative pa4" },
                                          [
                                            _c("div", {
                                              staticClass: "mt3 f4 cms-content",
                                              class: {
                                                "is-navy": index == 2,
                                                "is-yellow": index == 3,
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.marked(exp.text)
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            exp.button_cta.is_disabled
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg btn-disabled o-60",
                                                    attrs: {
                                                      title:
                                                        exp.button_cta.copy,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : exp.button_cta.is_sold_out
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg btn-generic btn-disabled o-60",
                                                    attrs: {
                                                      title:
                                                        exp.button_cta.copy,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "db mw6 mt4 btn-generic has-red-bg link pointer",
                                                    attrs: {
                                                      href: exp.button_cta.link,
                                                      title: "Buy" + exp.title,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            exp.button_cta.copy
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "dn db-ns absolute left-0 right-0 center vert-line-beige",
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "db relative mt4" }, [
                        _vm.page.cabanas_vs_box_suites.is_published
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "db relative mt3" },
                                    [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value:
                                              _vm.page.cabanas_vs_box_suites
                                                .mobile_image,
                                            expression:
                                              "page.cabanas_vs_box_suites.mobile_image",
                                          },
                                        ],
                                        staticClass: "db dn-ns relative w-100",
                                        attrs: {
                                          alt: _vm.page.cabanas_vs_box_suites
                                            .title,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "lazy",
                                            rawName: "v-lazy",
                                            value:
                                              _vm.page.cabanas_vs_box_suites
                                                .desktop_image,
                                            expression:
                                              "page.cabanas_vs_box_suites.desktop_image",
                                          },
                                        ],
                                        staticClass: "dn db-ns relative w-100",
                                        attrs: {
                                          alt: _vm.page.cabanas_vs_box_suites
                                            .title,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }